import { createSlice } from "@reduxjs/toolkit";

export const guardSlice = createSlice({
  name: "auth",
  initialState: {
    msisdn: null,
    checksub: null,
    phonenumbermsi: null,
    currentStatus: null,  // stores currentStatus from checksub response
    checkLang: 'en'       // stores active language preference
  },
  reducers: {
    setMsisdn: (state, action) => {
      state.msisdn = action.payload;
    },
    setChecksub: (state, action) => {
      state.checksub = action.payload;
    },
    setPhoneNumberMsi: (state, action) => {
      state.phonenumbermsi = action.payload;
    },
    setCurrentStatus: (state, action) => {
      state.currentStatus = action.payload;
    },
    setCheckLang: (state, action) => {
      state.checkLang = action.payload;
    }
  }
});

export const { setMsisdn, setChecksub, setPhoneNumberMsi, setCurrentStatus, setCheckLang, reset } = guardSlice.actions;
